var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: ""
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.588 5.4L3.688 10.3C3.488 10.5 3.25467 10.5958 2.988 10.5875C2.72133 10.5792 2.488 10.475 2.288 10.275C2.10467 10.075 2.00883 9.84167 2.0005 9.575C1.99217 9.30833 2.088 9.075 2.288 8.875L8.888 2.275C8.988 2.175 9.09633 2.10417 9.213 2.0625C9.32967 2.02083 9.45467 2 9.588 2C9.72133 2 9.84633 2.02083 9.963 2.0625C10.0797 2.10417 10.188 2.175 10.288 2.275L16.888 8.875C17.0713 9.05833 17.163 9.2875 17.163 9.5625C17.163 9.8375 17.0713 10.075 16.888 10.275C16.688 10.475 16.4505 10.575 16.1755 10.575C15.9005 10.575 15.663 10.475 15.463 10.275L10.588 5.4V16.575C10.588 16.8583 10.4922 17.0958 10.3005 17.2875C10.1088 17.4792 9.87133 17.575 9.588 17.575C9.30467 17.575 9.06717 17.4792 8.8755 17.2875C8.68383 17.0958 8.588 16.8583 8.588 16.575V5.4Z",
    fill: "#4CAF50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpIcon);
export default __webpack_public_path__ + "static/media/arrow-up-icon.8f014b98ac0aa605469a8735f8d21a20.svg";
export { ForwardRef as ReactComponent };